import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  originalPriceWithPeriod: {
    defaultMessage: '{price}/{period}',
    description: 'Original price with billing period (month or year)',
    id: 'yzbFOt',
  },
  perMonth: {
    defaultMessage: ' per mo.',
    description: 'Monthly pricing suffix for strikethrough price',
    id: 'JYBUmH',
  },
  perYear: {
    defaultMessage: ' per year',
    description: 'Annual pricing suffix for strikethrough price',
    id: 'gsTvF3',
  },
  pricePerMonth: {
    defaultMessage: '{price} per mo.',
    description: 'Discounted monthly price display',
    id: 'tO63Rz',
  },
  pricePerYear: {
    defaultMessage: '{price} per year',
    description: 'Discounted annual price display',
    id: 'rO1sP7',
  },
});
